import React from 'react';

import MultiStateButton from './redesign/multiStateButton/multiStateButton';
import WarningBell from '../../../assets/svgComponents/WarningBell';
import VIDABOO_CONSTANTS from '../../../config/consts';

import './mentorNotificationComponent.css';

const MentorNotificationComponent = ({
  showAcceptBtnSpinner,
  showRejectBtnSpinner,
  acceptBtnTxt,
  closeBtnTxt,
  rejectBtnTxt,
  notificationInfoTxt,
  notificationInfoTxtComponent,
  notificationTxt,
  notificationType,
  acceptBtnFunc,
  closeBtnFunc,
  rejectBtnFunc,
}) => {
  return (
    <div className="et-mentor-notification-container">
      <div className="et-mentor-notification-content-wrap">
        <div className="et-mentor-notification-bell-msg-wrap">
          {notificationType ===
            VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING && (
            <div className="et-mentor-notification-bell">
              <WarningBell />
            </div>
          )}
          <div className="et-mentor-notification-msg">{notificationTxt}</div>
        </div>
        {notificationInfoTxtComponent
          ? notificationInfoTxtComponent
          : notificationInfoTxt && (
              <div className="et-mentor-notification-info-txt">
                {notificationInfoTxt}
              </div>
            )}
        <div className="et-mentor-notification-btns-wrap">
          {!rejectBtnTxt && !acceptBtnTxt && !closeBtnTxt ? (
            <div className="et-mentor-notification-btn">
              <MultiStateButton btnTxt={'OK'} onClick={closeBtnFunc} />
            </div>
          ) : null}
          {closeBtnTxt ? (
            <div className="et-mentor-notification-btn">
              <MultiStateButton btnTxt={closeBtnTxt} onClick={closeBtnFunc} />
            </div>
          ) : null}
          {rejectBtnTxt ? (
            <div className="et-mentor-notification-btn">
              <MultiStateButton
                isDeleteBtn
                showSpinner={showRejectBtnSpinner}
                btnTxt={rejectBtnTxt}
                onClick={rejectBtnFunc}
              />
            </div>
          ) : null}
          {acceptBtnTxt ? (
            <div className="et-mentor-notification-btn">
              <MultiStateButton
                isPrimaryBtn
                showSpinner={showAcceptBtnSpinner}
                btnTxt={acceptBtnTxt}
                onClick={acceptBtnFunc}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MentorNotificationComponent;
